import axios from "../../utils/axios";

// 库存管理
export function getList(query) {
    return axios({
        url: "repertoryManage/getList",
        method: "get",
        params: query
    });
}
//库存删除
export function deleteRepertory(data) {
    return axios({
        url: "repertoryManage/delete",
        method: "post",
        data: data
    });
}
// 库存增加
export function addRepertory(data) {
    return axios({
        url: "repertoryManage/update",
        method: "post",
        data: data
    });
}

// 库存修改
export function updateRepertory(data) {
    return axios({
        url: "repertoryManage/update",
        method: "post",
        data: data
    });
}

// 查询发货仓
export function getComRepertorys() {
    return axios({
        url: "repertoryManage/getComRepertorys",
        method: "get"
    });
}

// 查询分类
export function getClassify() {
    return axios({
        url: "repertoryManage/getComClassify",
        method: "get"
    });
}

//分类联动查询品牌
export function getBrand() {
    return axios({
        url: "repertoryManage/getComBrand",
        method: "get"
    });
}

//查询规格
export function getSpec(data) {
    return axios({
        url: "repertoryManage/getComSpec?id="+data,
        method: "get"
    });
}

// 查询商品
export function getAddRecomCommodityList(data) {
    return axios({
        url: "commodityManage/getList",
        method: "get",
        params: data
    });
}





